import React from 'react';
import { get } from 'lodash';
import styled from 'styled-components';

import CustomSelect from '../common/Select';
import ChartOptions from '../common/ChartOptions';
import { ALL_CHART_VIEWS, BASIC_CHART_VIEWS } from '../../constants/event';
import CacheEnableCheckBox from '../../containers/common/CacheEnableCheckBox';
import ChartMode from './ChartMode';
import FormulaLink from './FormulaLink';
import Formula from './EventFormula';

const StyledDiv = styled.div`
  .options-bar {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .options-bar-formula-component {
    width: 65%;
  }

  .options-bar-chart-view {
    display: flex;
    align-items: center;
  }

  .options-bar-formula-link {
    display: flex;
    align-items: center;
  }

  .right-indent {
    margin-right: 5px;
  }
`;

const StyledCacheEnableCheckBox = styled(CacheEnableCheckBox)`
  margin-left: 10;
  color: #1890ff;
`;

const EventExecutionOptionsBar = (props) => {
  const {
    onChangeView,
    onChangeChartMode,
    onChangeVisibleFormula,
    options,
    result,
    onChangeSorting,
  } = props;

  const { view, singleChartMode, showFormula, views, enteredFormula } = options;

  const isMultipleEventsExcludeAdditionalPeriodEvents =
    result.filter(({ info }) => info.uniqueChar.length === 1 || info.uniqueChar.includes('Others'))
      .length > 1;

  const compareSplits = (event) =>
    get(result, '[0].info.query.groupBy[1]', '') === get(event, 'info.query.groupBy[1]', '');

  const isSplitSame = () => !!result.length && result.every(compareSplits);

  const isChartView = BASIC_CHART_VIEWS.includes(view);
  const isShowChartMode =
    !!enteredFormula ||
    (ALL_CHART_VIEWS.includes(view) && isMultipleEventsExcludeAdditionalPeriodEvents);

  return (
    <StyledDiv>
      <div className="options-bar">
        <div>
          <div className="options-bar-chart-view">
            <span className="right-indent">View:</span>
            <CustomSelect
              allowClear={false}
              value={view}
              values={views}
              style={{ width: 'auto', minWidth: 85 }}
              className="ant-select-border-bottom"
              onChange={(viewParam) => onChangeView(viewParam)}
            />
          </div>
        </div>
        <div className="options-bar-formula-link">
          {isChartView && (
            <>
              <FormulaLink isSplitSame={isSplitSame(result)} onClick={onChangeVisibleFormula} />
              <ChartOptions {...options} {...props} onChangeSorting={onChangeSorting} />
            </>
          )}
          {isShowChartMode && (
            <ChartMode onChangeChartMode={onChangeChartMode} singleChartMode={singleChartMode} />
          )}
          <StyledCacheEnableCheckBox />
        </div>
      </div>
      {isChartView && (
        <div className="options-bar-formula-component">{showFormula && <Formula {...props} />}</div>
      )}
    </StyledDiv>
  );
};

export default EventExecutionOptionsBar;
